export default __webpack_public_path__ + "static/media/plus.cac2a8b4.svg";